var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColLinkImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.907245 13.5292V4.7832C0.598791 4.86486 0.290294 4.96467 0 5.05538V16.0967C2.43527 15.4236 5.02304 15.5573 7.37601 16.4778C5.77701 14.861 3.59853 13.9498 1.32461 13.9465C1.09611 13.9417 0.912093 13.7577 0.907245 13.5292Z",
    fill: "#D31C4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76062 2.39648L1.7334 13.1566C4.40406 13.2949 6.89482 14.5452 8.60133 16.6042V6.34306C7.04333 4.052 4.52381 2.59845 1.76062 2.39648Z",
    fill: "#D31C4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0922 4.80078V13.5377C17.0874 13.7661 16.9033 13.9502 16.6749 13.955C14.406 13.957 12.2327 14.8688 10.6416 16.4863V16.4953C12.9868 15.5716 15.5681 15.4315 17.9995 16.0961V5.07292C17.7092 4.97315 17.4098 4.87338 17.0922 4.80078Z",
    fill: "#D31C4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2768 2.39648C13.5026 2.57838 10.9694 4.03597 9.41797 6.34306V16.6042C11.1224 14.5474 13.6094 13.2974 16.2768 13.1566V2.39648Z",
    fill: "#D31C4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColLinkImg);
export default __webpack_public_path__ + "static/media/ColLinkImg.63d62cd5116bb1ad48ba60f886ba4b9a.svg";
export { ForwardRef as ReactComponent };